export const getShadeFromPercent = (hex: string, percent: number): string => {
  const hexToHSL = (H: string) => {
    let r = 0,
      g = 0,
      b = 0
    if (H.length === 4) {
      r = parseInt(H[1] + H[1], 16)
      g = parseInt(H[2] + H[2], 16)
      b = parseInt(H[3] + H[3], 16)
    } else {
      r = parseInt(H[1] + H[2], 16)
      g = parseInt(H[3] + H[4], 16)
      b = parseInt(H[5] + H[6], 16)
    }

    r /= 255
    g /= 255
    b /= 255

    const max = Math.max(r, g, b)
    const min = Math.min(r, g, b)
    let h = 0,
      s = 0,
      l = (max + min) / 2

    if (max !== min) {
      const d = max - min
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0)
          break
        case g:
          h = (b - r) / d + 2
          break
        case b:
          h = (r - g) / d + 4
          break
      }
      h /= 6
    }

    return { h, s, l }
  }

  const hslToCSS = (h: number, s: number, l: number) =>
    `hsl(${Math.round(h * 360)}, ${Math.round(s * 100)}%, ${Math.round(l * 100)}%)`

  const { h, s } = hexToHSL(hex)
  const minL = 0.3
  const maxL = 0.9
  const l = maxL - (percent / 100) * (maxL - minL)

  return hslToCSS(h, s, l)
}
